import { Col, GRID } from '../../components/custom';

export default function PEA()
{
    return (
        <Col id='PEA' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Identifying High-Impact Drivers of Engagement</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To determine which experience dimensions have the greatest impact on employees' <strong>overall engagement scores.</strong></span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Approach: Multiple Linear Regression</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Dependent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Engagement Score</strong> (1-5 scale)</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Independent Variables</span>
                        <ul>
                            <li className='descsmall'>Work-Life Balance</li> 
                            <li className='descsmall'>Enablement</li>
                            <li className='descsmall'>Team Connection</li>
                        </ul>
                        <span className='descsmall'>Each variable was measured on a 1-5 Likert scale.</span>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <GRID className='_4x4'>
                            <span className='descsmall bold'>Driver</span>
                            <span className='descsmall bold'>Std. Coefficient</span>
                            <span className='descsmall bold'>P-value</span>
                            <span className='descsmall bold'>Interpretation</span>
                            <span className='descsmall bold left'>Enablement</span>
                            <span className='descsmall'>0.900</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>The strongest predictor — employees who feel enabled are significantly more engaged.</span>
                            <span className='descsmall bold left'>Work-Life Balance</span>
                            <span className='descsmall'>0.665</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Strong and significant — balance contributes meaningfully to engagement.</span>
                            <span className='descsmall bold left'>Team Connection</span>
                            <span className='descsmall'>0.455</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Moderate impact — connection with team helps reinforce engagement.</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Insightful Takeaway:</span>
                        <span className='descsmall'>Enablement emerged as the <strong>top driver of engagement</strong>, followed by work-life balance and team connection. This indicates that employees are most engaged when they feel empowered to do their job well, supported by a sustainable rhythm and strong team cohesion.</span>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}